var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHair1Back(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 962.4 995.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-hair-1 {\n        fill: var(--custom-color, #fa) !important;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-hair-1",
    d: "M870.56,145.75C726.79-64.5,353.01,14.57,353.01,14.57c0,0-257.25,36.53-326.3,275.24C6.34,360.25-.48,423.92.03,478.7c-.51,54.78,6.31,118.45,26.69,188.89,69.05,238.71,326.3,275.24,326.3,275.24,0,0,373.78,79.07,517.55-131.18,83.25-121.76,95.5-248.13,91.06-332.95,4.44-84.82-7.81-211.19-91.06-332.95Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-hair-1",
    points: "281.13 914.89 322.26 983.07 356.78 953.31 401.93 992.25 440.97 958.59 481.87 993.85 517.85 962.82 555.53 995.31 594.74 961.5 628.99 991.03 687.69 929.26 281.13 914.89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair1Back);
export default __webpack_public_path__ + "static/media/hair1-back.1ad54b63e0d2a7c62ede4c9dc555f9f9.svg";
export { ForwardRef as ReactComponent };